import { render, staticRenderFns } from "./WorkspaceCanvas.vue?vue&type=template&id=59d12dbc&scoped=true"
import script from "./WorkspaceCanvas.vue?vue&type=script&lang=js"
export * from "./WorkspaceCanvas.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCanvas.vue?vue&type=style&index=0&id=59d12dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d12dbc",
  null
  
)

export default component.exports